<template >
    <div class="flex ">
        <div  v-for="(item,index) in qtdPaginas" :key="item.valor" >

            <div class="  w-6 h-6 ml-1 rounded-sm shadow-lg"
                 :class="{'bg-primary': item.selecionado}">
                <button   class="ml-2 "
                          :class="{'text-white': item.selecionado}"
                          @click="atualizarSelecionado(index)"
                > 
                    {{item.valor}} 
                </button>
            </div>
          
        </div>
      
        
    </div>
</template>
<script lang='ts'>
import { defineComponent, ref, watch } from 'vue';
import vmRelatorio from '@/ViewModel/ConsultaRelatorioViewModel';

export default defineComponent({
    name: 'Paginacao',
    emits: ['consultarPeriodoPaginacao'],                       
    
    setup (props, { emit }) {
        const selecionado = ref();
        const qtdPaginas = ref<{valor: number, selecionado: boolean}[]>([]);
        let valorSelecionadoAnterior = 0;

        const atualizarSelecionado = (index: number) => {
            let valorRequestPaginacao = index + 1;
            vmRelatorio.paginas.paginaAtual = valorRequestPaginacao.toString();
            emit("consultarPeriodoPaginacao", "");
            
            if (qtdPaginas.value[valorSelecionadoAnterior]) {
                qtdPaginas.value[valorSelecionadoAnterior].selecionado = false;
            }
            if (qtdPaginas.value[index]) {
                qtdPaginas.value[index].selecionado = true;
            }
            
            valorSelecionadoAnterior = index;
        };

        watch(
            () => vmRelatorio.paginas.quantidadePaginas,
            (novaQuantidade) => {
                qtdPaginas.value = [];
                
                if(novaQuantidade > 0) {
                    for (let i = 1; i <= novaQuantidade; i++) {
                        qtdPaginas.value.push({ valor: i, selecionado: false });
                    }
                    qtdPaginas.value[0].selecionado = true;
                }
            },
            { immediate: true }
        );

        return { 
            selecionado,
            qtdPaginas,
            atualizarSelecionado,
        };
    }
});
</script>